
import {Component, Vue} from 'vue-property-decorator';
import {readAdminUsers} from '@/store/admin/getters';
import {dispatchDeleteUser, dispatchGetUsersAdmin} from '@/store/admin/actions';
import DynamicTableSimpleAsync from '@/components/datatables/DynamicTableSimpleAsync.vue';
import {SpecialFields} from "@/interfaces/constants";

@Component({
  components: {DynamicTableSimpleAsync},
})
export default class UserList extends Vue {

  public headers = [
    {text: this.$t('action'), value: 'action', align: 'center', filterable: false, sortable:
          false, router_name: 'main-admin-users-edit', width: '125px', delete_function: this.deleteUser},
    {
      text: this.$t('username'),
      sortable: true,
      value: 'username',
      align: 'left',
      width: 100,
    },
    {
      text: this.$t('email'),
      sortable: true,
      value: 'email',
      align: 'left',
      width: 250,
    },
    {
      text: this.$t('fullName'),
      sortable: true,
      value: 'fullname',
      align: 'left',
      width: 250,
    },
    {
      text: this.$t('permissions'),
      sortable: false,
      value: 'all_permissions',
      align: 'center',
      width: 100,
      special_field: SpecialFields.PermissionVisualizer
    },
    {
      text: this.$t('origin_location'),
      sortable: true,
      value: 'origin_location',
      align: 'left',
      width: 100,
    },
    {
      text: `${this.$t('isActive')}?`,
      sortable: false,
      value: 'is_active',
      align: 'center',
      width: 80,
    },
    {
      text: `${this.$t('committee_member')}?`,
      sortable: false,
      value: 'committee_member',
      align: 'center',
    },
    {
      text: `${this.$t('professional_council')}`,
      sortable: false,
      value: 'professional_council',
      align: 'left',
      width: 100,
    },
    {
      text: `${this.$t('council_type')}`,
      sortable: false,
      value: 'council_type',
      align: 'left',
      width: 100,
    },
    {
      text: `${this.$t('ses_registration')}`,
      sortable: false,
      value: 'ses_registration',
      align: 'left',
      width: 100,
    },
    {
      text: `${this.$t('document2')}`,
      sortable: false,
      value: 'document',
      type: 'document',
      align: 'left',
      width: 100,
    },

    {
      text: `${this.$t('personal_document2')}`,
      sortable: false,
      value: 'personal_document',
      type: 'document',
      align: 'left',
      width: 100,
    },
  ];

  private numberOfPages: number = 0;
  private totalItems: number = 0;

  get users() {
    return readAdminUsers(this.$store);
  }

  public async loadDataAPI(payload: any) {
    payload.with_stats = false;
    const response = await dispatchGetUsersAdmin(this.$store, payload);

    if (response) {
      this.totalItems = response?.total_items;
      this.numberOfPages = response?.total_items_page;
    }
  }

  public async mounted() {
    // await dispatchGetUsersAdmin(this.$store, {skip: 0, limit: 10});
  }

  private async deleteUser(id) {
    await dispatchDeleteUser(this.$store, id);
    await dispatchGetUsersAdmin(this.$store, {skip: 0, limit: 10});
  }
}
